
import CesiumScreenSpaceEventService, { GCS_FEATURE, GCS_MODE, MISSION_MODE_STATE } from "@/services/cesium/cesium_screen_space_ev_service";
import CustomAlert from "@/services/hg/custom_alert";
import MissionWaypointGeneratingManager from "@/services/hg/mission/mission_generating_tool_manager";
import MissionManager, { MissionItem, MissionItemType, MissionObject } from "@/services/hg/mission/mission_manager";
import store from "@/store";
import { computed, defineComponent } from "vue";
export default defineComponent({
  data() {
    return {
      mission_arr: [] as MissionItem[],
      tab_open: false,
      modify_name: '',
      modify_state: false,
      panel: [] as any,
      history_mission_item: [] as MissionItem[],
      history_state: false,
      history_num: 0 as number,
    };
  },
  mounted() {
    window.addEventListener('keydown', this.handleKeydown);
  },
  beforeDestroy() {
    window.removeEventListener('keydown', this.handleKeydown);
  },
  setup() {
    
    const side_mission_Detail_tab = computed(
      () => store.getters.GetSideMissionDetailTab
    );
    const side_mission_tab = computed(() => store.getters.GetSideMissionTab);
    const mission = computed(() => MissionManager.getInstance().GetModifyMission());
    const mission_alias = computed(() => MissionManager.getInstance().GetMissionAlias());
    const edit_mission_name = computed(() => store.getters.GetEditMissionName);
    const waypoint_index_list = MissionManager.getInstance().GetSelectWaypointList()
    return { side_mission_Detail_tab, mission, side_mission_tab, edit_mission_name, waypoint_index_list, mission_alias };
  },

  watch: {
    mission: {
      deep: true,
      handler(n, o) {
        const ClickState = CesiumScreenSpaceEventService.getInstance().GetClickState()
        if(ClickState) {this.mission_arr = n} else {
          const GetMissionObj:MissionObject = store.getters.GetMissionData
          const newHistoryItem:MissionObject = {
            _id : GetMissionObj._id,
            account : GetMissionObj.account,
            alias : GetMissionObj.alias,
            items : JSON.parse(JSON.stringify(n)),
          }
          if(this.history_state == false) {
            this.mission_arr = n
            if(this.history_num == 0) {
              const postHistoryItem:MissionObject = {
                _id : GetMissionObj._id,
                account : GetMissionObj.account,
                alias : GetMissionObj.alias,
                items : JSON.parse(JSON.stringify(this.history_mission_item)),
              }
              MissionManager.getInstance().SetMissionHistory(postHistoryItem)
            }
            this.history_num += 1 
            MissionManager.getInstance().SetMissionHistory(newHistoryItem)
          }
          this.history_mission_item = JSON.parse(JSON.stringify(this.mission_arr))
          this.history_state = false
        }
      },
    },
    side_mission_Detail_tab: {
      handler(n, o) {
        this.tab_open = n;
        this.modify_state = false
      },
    },
    waypoint_index_list: {
      handler(n, o) {
        this.panel = n
        const scroll_y:any = this.$refs.scroll_container
        scroll_y.scrollTop = n[0]*60
      }
    }
  },

  methods: {    
    // onClickModifyMission() {
    //   MissionManager.getInstance().SetGCSMode(GCS_MODE.MISSION_UPDATE)
    //   MissionManager.getInstance().SetSelectedMissionEntity(this.mission.alias);
    //   CesiumScreenSpaceEventService.getInstance().setMissionMode(MissionItemType.NONE)
    //   this.modify_state = true;
    //   store.commit("SetFacialRecognition", false);
    //   store.commit("SetSideMenuTab", false);
    //   store.commit("SetShowSingle", false);
    //   store.commit("SetShowCommandSingle", true);
    //   store.commit("SetLogMessageState", false)
    //   CesiumScreenSpaceEventService.getInstance().SetMissionCameraMove(this.mission)
    // },
    // onClickModifyMissionSave() {
    //   const mission_modify_arr :MissionItem[] = MissionManager.getInstance().GetModifyMission()
    //   store.commit("SetMissionPacket", { 
    //     _id: this.mission._id, 
    //     alias: this.edit_mission_name === '' ? this.mission.alias : this.edit_mission_name, 
    //     items: mission_modify_arr
    //   })
    //   store.commit("SetModalType", 'modify_mission_save')
    //   store.commit("SetModalWindow", true)
    // },
    onClickModifyMissionSave() {
      // const mission_modify_arr :MissionItem[] = MissionManager.getInstance().GetModifyMission()
      // MissionManager.getInstance().SetMissionPacket(mission_modify_arr)
      store.commit("SetModalType", 'modify_mission_save')
      store.commit("SetModalWindow", true)
    },
    onClickEditMissionName() {
      store.commit("SetModalType", 'modify_mission_name')
      store.commit("SetModalWindow", true)
    },
    altSelect(num: number, index: number) {
      // num === 1
      //   ? (this.mission.waypoint[0][index][0].selectAlt = "alt")
      //   : num === 2
      //     ? (this.mission.waypoint[0][index][0].selectAlt = "absolalt")
      //     : null;
    },
    setNumber(num: number, index: number, pm: string) {
      // const set =
      //   num === 1 ? "alt" : num === 2 ? "absolalt" : num === 3 ? "wait" : null;
      // const setNum = this.mission.waypoint[0][index][0][`${set}`];
      // this.mission.waypoint[0][index][0][`${set}`] =
      //   pm === "plus" ? setNum + 1 : setNum - 1;
    },
    onClickDelete(mission_item:MissionItem) {
      if(mission_item.type == MissionItemType.ARM) {
        CesiumScreenSpaceEventService.getInstance().SetDeleteMissionItem(mission_item) // ARM
        CesiumScreenSpaceEventService.getInstance().SetDeleteMissionItem(this.mission[0]) // TAKEOFF
      } else if(mission_item.type == MissionItemType.TAKEOFF) {
        CesiumScreenSpaceEventService.getInstance().SetDeleteMissionItem(mission_item) // TAKEOFF
        CesiumScreenSpaceEventService.getInstance().SetDeleteMissionItem(this.mission[0]) // ARM
      } else {
        CesiumScreenSpaceEventService.getInstance().SetDeleteMissionItem(mission_item)
      }
    },
    back() {
      store.commit("SetSideMissionTab", true);
      store.commit("SetSideMissionDetailTab", false);
      store.commit("SetMissionData", []);
      store.commit("SetEditMissionName", '');
      CesiumScreenSpaceEventService.getInstance().SetMode(GCS_FEATURE.NORMAL);
      MissionWaypointGeneratingManager.getInstance().SetOptsDefault();
      store.commit("SetMissionModeState", MISSION_MODE_STATE.OFF);
      MissionManager.getInstance().SetWaypointBoxState(false)
      MissionManager.getInstance().SetGCSMode(GCS_MODE.NORMAL)
      MissionManager.getInstance().SetMissionEntityVisible()
      MissionManager.getInstance().AllClearMissionHistory()
    },
    setUpdateAlt(num: number, mission: MissionItem, type:string) {
      //content == 1 --> Altitude
      if(type == 'Altitude') {
        CesiumScreenSpaceEventService.getInstance().SetMissionUpdateAlt(num, mission)
      //content == 2 --> Wait
      } else if(type == 'Wait') {
        CesiumScreenSpaceEventService.getInstance().SetMissionUpdateTime(num, mission)
      }
      this.history_state = false
    },
    handleAltChange(mission_item:MissionItem) {
      CesiumScreenSpaceEventService.getInstance().SetMissionUpdateInputAltitude(mission_item)
    },
    WaypointLocation(lng:number, lat:number, alt:number) {
      MissionManager.getInstance().WaypointLocation(lng, lat, alt)
    },
    setUpdateGeo(event:any, type:string, mission:MissionItem) {
      CesiumScreenSpaceEventService.getInstance().SetMissionUpdateGeo(event.target.value, type, mission)
    },
    onClickWaypointMove(num:number, mission_item: MissionItem) {
      if(num == 1) {
        if(this.mission_arr[Number(mission_item.id)-1]) {
          const MissionType = this.mission_arr[Number(mission_item.id)-1].type;
          if(MissionType == MissionItemType.WAYPOINT 
          || MissionType == MissionItemType.ROION 
          || MissionType == MissionItemType.ROIOFF) 
          {
            this.panel = [];
            [this.mission_arr[Number(mission_item.id)], this.mission_arr[Number(mission_item.id)-1]] = [this.mission_arr[Number(mission_item.id)-1], this.mission_arr[Number(mission_item.id)]];
            this.mission_arr[Number(mission_item.id)].id = mission_item.id;
            this.mission_arr[Number(mission_item.id)-1].id = String(Number(mission_item.id)-1);
            this.panel = [Number(mission_item.id)]
          } else {
            CustomAlert.getInstance().ShowAlert("Invaild Location");
          }
        } else {
          CustomAlert.getInstance().ShowAlert("Invaild Location");
        }
        
      } else if(num == -1) {
        if(this.mission_arr[Number(mission_item.id)+1]) {
          const MissionType = this.mission_arr[Number(mission_item.id)+1].type;
          if(MissionType == MissionItemType.WAYPOINT 
          || MissionType == MissionItemType.ROION 
          || MissionType == MissionItemType.ROIOFF)
          {
            this.panel = [];
            [this.mission_arr[Number(mission_item.id)], this.mission_arr[Number(mission_item.id)+1]] = [this.mission_arr[Number(mission_item.id)+1], this.mission_arr[Number(mission_item.id)]];
            this.mission_arr[Number(mission_item.id)].id = mission_item.id;
            this.mission_arr[Number(mission_item.id)+1].id = String(Number(mission_item.id)+1);
            this.panel = [Number(mission_item.id)]
          } else {
            CustomAlert.getInstance().ShowAlert("Invaild Location");
          }
        } else {
          CustomAlert.getInstance().ShowAlert("Invaild Location");
        }
      }
      CesiumScreenSpaceEventService.getInstance().SetMoveMissionArr(this.mission_arr)
    },
    handleKeydown(e:any) {
      if ((e.ctrlKey || e.metaKey) && e.key === 'z') {
        if(MissionManager.getInstance().GetMissionHistory().length > 1) {
          this.history_state = true
          CesiumScreenSpaceEventService.getInstance().DeleteMissionEntities(this.mission_arr)
          const MissionHistory = MissionManager.getInstance().GetMissionHistory()
          if(MissionManager.getInstance().GetMissionHistory().length == 1) { null } else {
            if(JSON.stringify(this.mission_arr) === JSON.stringify(MissionHistory[0].items)) {
              // 되돌리기 작업 초기에, MissionHistory 배열 가장 최신값이 현재 상태값이랑 겹치기 때문에 최신값 제거 필요 
              MissionManager.getInstance().ClearMissionHistory()
            }
          }
          MissionManager.getInstance().SetModifyAllMission(MissionHistory[0].items)
          CesiumScreenSpaceEventService.getInstance().SetHistoryMissionPath(MissionHistory[0].items)
          CesiumScreenSpaceEventService.getInstance().setMissionMode(MissionItemType.NONE)// 모드를 다시 정해줘야 바뀐 값으로 수정이 가능
          this.mission_arr = MissionHistory[0].items
          MissionManager.getInstance().ClearMissionHistory()
        }
        this.history_num = 0
      }
    }
  },
});
